if (!customElements.get('gift-voucher-form')) {
  customElements.define(
    'gift-voucher-form',
    class GiftVoucherForm extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[data-gift-voucher-variant-input]');
        this.amountDisplay = this.querySelector('[data-gift-voucher-amount]');
        this.offsetInput = this.querySelector('[data-gift-voucher-offset]');
        this.amountOptions = this.querySelectorAll('.gift-voucher__amount-option');

        if (this.offsetInput) {
          this.offsetInput.value = String(new Date().getTimezoneOffset());
        }

        this.querySelectorAll('input[name="gift-voucher-amount"]').forEach((input) => {
          input.addEventListener('change', () => this.onAmountChange(input));
        });
      }

      onAmountChange(input) {
        if (!input || !input.checked) return;

        if (this.variantInput) {
          this.variantInput.value = input.value;
          this.variantInput.disabled = false;
        }

        const card = this.querySelector('[data-gift-voucher-card]');
        if (card) card.classList.add('is-updating');

        if (this.amountDisplay) {
          window.requestAnimationFrame(() => {
            this.amountDisplay.textContent = input.dataset.priceFormatted || '';
            if (card) {
              window.setTimeout(() => card.classList.remove('is-updating'), 180);
            }
          });
        }

        this.amountOptions.forEach((option) => {
          option.classList.toggle('is-selected', option.contains(input));
        });
      }
    }
  );
}
